var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPartilhar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-140 -639)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    transform: "translate(140 639)",
    fill: "#0c1151",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.757,25.88a4.421,4.421,0,0,0-3.164,1.212l-11.6-6.706a5.434,5.434,0,0,0,.162-1.132,5.431,5.431,0,0,0-.162-1.132L25.431,11.5a4.855,4.855,0,1,0-1.542-3.555,5.4,5.4,0,0,0,.162,1.132L12.613,15.7a4.883,4.883,0,0,0-3.326-1.292A4.8,4.8,0,0,0,4.5,19.254a4.884,4.884,0,0,0,8.194,3.555l11.52,6.706a4.053,4.053,0,0,0-.162,1.05,4.705,4.705,0,1,0,4.705-4.686Z",
    transform: "translate(140.938 639.827)",
    fill: "#0c1151"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPartilhar);
export default __webpack_public_path__ + "static/media/icon-partilhar.6568e45484495633eaad92167c50d88e.svg";
export { ForwardRef as ReactComponent };